/**
 * Get the site URL. Always returns the production URL for static builds
 * so canonical and OG tags are never set to a Netlify preview domain.
 */
export function getSiteUrl(): string {
  return 'https://universal-sign-in.com'
}
